import { computed } from '@vue/composition-api'
import { min, parse } from '@/utils/formatDate'
import Days from './components/Days/Days'

export default ({
  props: {
    data: Object,
  },
  components: {
    Days,
  },
  setup(props) {
    const dayPanels = []
    const groupedTime = computed(() => props.data.groupedTime)

    return {
      dayPanels,
      groupedTime,
      min,
      parse,
    }
  },
})
